import { OfferProgressFormatVariant } from '../offer-card/offer-card.types';

import type { IntlShape } from 'react-intl';

type FormatOfferProgressValueParams = {
  value: number;
  variant?: OfferProgressFormatVariant;
  currency?: string;
  /** From `useIntl().formatNumber` — keeps currency formatting aligned with app locale and react-intl config. */
  formatNumber: IntlShape['formatNumber'];
};

const DEFAULT_CURRENCY = 'USD';

export const formatOfferProgressValue = ({
  value,
  variant = 'quantity',
  currency,
  formatNumber,
}: FormatOfferProgressValueParams): string | number => {
  if (variant === 'money-amount') {
    return formatNumber(value, {
      style: 'currency',
      currency: currency || DEFAULT_CURRENCY,
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  }

  return value;
};
